<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-radio-group button-style="solid" v-model="dimension" @change="init_data">
          <a-radio-button value="channel">
            渠道
          </a-radio-button>
          <a-radio-button value="ad_type">
            类型
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item>
        <a-select v-model="product" style="width: 240px" allowClear showSearch
                  :maxTagCount="1" placeholder="请选择产品"
                  optionFilterProp="label"
                  @change="init_data()">
          <a-select-option v-for="productItem in $store.getters.getAppAll"
                           :label="productItem.app_name"
                           :value="productItem.app_id"
                           :key="productItem.app_id">
            <img :src="productItem.icon" style="height: 28px;border-radius: 5px;">
            {{productItem.app_name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select v-model="channel" style="width: 200px" allowClear
                  mode="multiple" :maxTagCount="1" optionFilterProp="label" placeholder="请选择展示渠道"
                  @change="init_data">
          <a-select-option v-for="channelItem in $store.state.RevenueChannel"
                           :label="channelItem.name"
                           :value="channelItem.value"
                           :key="channelItem.value">
            {{channelItem.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-tooltip style="cursor: pointer">
          <template slot="title" >
            <div v-for="item_channel in Object.keys($store.state.RevenueChange)">
              渠道：{{item_channel}} <br>
              处理：{{$store.state.RevenueChange[item_channel]}}
            </div>
          </template>
          规则<a-icon type="info-circle" theme="filled" />
        </a-tooltip>
      </a-form-item>
      <a-form-item style="float: right;margin: 0">
        <a-button type="primary" @click="downLoad" >导出</a-button>
      </a-form-item>
      <a-form-item style="float: right">
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="init_data()" />
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" id="show-table"
             style="flex: 1;overflow-y: hidden;background: #ffffff"
             :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }"
             :data-source="tableData"
             :rowKey="item=>item.dimension" :loading="tableLoad"
             bordered :pagination="false">
      <!--<template slot="footer"  slot-scope="currentPageData">-->
      <!--  <a-pagination-->
      <!--    v-model="page"-->
      <!--    style="text-align: right"-->
      <!--    show-size-changer-->
      <!--    :total="count"-->
      <!--    :page-size="page_size"-->
      <!--    @change="changePage"-->
      <!--    @showSizeChange="changePage"-->
      <!--  />-->
      <!--</template>-->
    </a-table>
  </div>
</template>

<script>
import {GetCashCheck} from "../../../api/v1/cash_api";

export default {
  name: "Index",
  data(){
    return {
      dimension:'channel',
      channel:[],
      product:undefined,
      date:['',''],
      tableData:[],
      fields:[],
      tableLoad:false
    }
  },
  mounted() {
    this.init_data()
  },
  computed: {
    getTableColumns(){
      let _table_columns = [
        {title: '维度指标',width:200, dataIndex: 'dimension',fixed:'left',align:'center'},
      ]
      this.fields.forEach(item=>{
        _table_columns.push({
          title: item,
          dataIndex: item,
          width: 150,
          align:'center'
        })
      })
      _table_columns.push({title: '汇总',width:150, dataIndex: 'count',fixed:'right',align:'center'})
      return _table_columns
    }
  },
  methods:{
    init_data(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetCashCheck({
        app_id:this.product,
        dimension:this.dimension,
        start:this.date[0],
        end:this.date[1],
        channel:this.channel
      }).then(resp=>{
        this.tableLoad = false
        if (resp.code===200){
          this.date = resp.data.date
          this.tableData = resp.data.list
          this.fields = resp.data.fields
        }
      })
    },
    changeDate(){
      console.log(this.date)
    },
    changeChannel(){
      console.log(this.channel)
    },
    downLoad(){
      let name = "周期维度细分数据"
      name += this.date[0]+"至"+this.date[1]+"的"
      this._export_cvs(Object.values(this.tableData),this.getTableColumns,name)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Revenue/Check/Index.vue